export const SESSION_STORAGE = 'sessionStorage';
